import api from '@/utils/api/api'

type RequestOptions = {
  signal?: AbortSignal
}

export type BrandAlias = {
  id: string
  brandId: string
  alias: string
  createdAt: string
}

type BrandAliasListResponse = { aliases: BrandAlias[] }

type BrandAliasResponse = { alias: BrandAlias }

const BRANDS_PATH = '/brands'

const getAliasesPath = (brandId: string) => `${BRANDS_PATH}/${brandId}/aliases`

export const brandsApi = {
  getAliases: async (brandId: string, options?: RequestOptions) => {
    const { data } = await api.get<BrandAliasListResponse>(
      getAliasesPath(brandId),
      { signal: options?.signal }
    )
    return data.aliases
  },
  createAlias: async (brandId: string, alias: string) => {
    const { data } = await api.post<BrandAliasResponse>(
      getAliasesPath(brandId),
      { alias }
    )
    return data.alias
  },
  deleteAlias: async (brandId: string, aliasId: string) => {
    await api.delete(`${getAliasesPath(brandId)}/${aliasId}`)
  },
}
